import gql from 'graphql-tag'
export default gql`query plantQuery($id: Int!) {
  plant(id: $id) {
    name
    id
  }
}`